import api from './api';

class UserService {
  async searchUsers(nickname, limit) {
    const response = await api.get('/users', { params: { nickname, limit } });
    return response.data;
  }

  // `changes` solo debe llevar los campos que realmente cambian
  // (nickname y/o email), ya que es un PATCH parcial.
  async updateProfile(changes) {
    const response = await api.patch('/users/me', changes);
    return response.data;
  }
}

export default new UserService();